import type { FaireProductEntity } from "../../entity_types/product";

export const p_y7gmmg3sr2: FaireProductEntity = {
  token: "p_y7gmmg3sr2",
  type: "product",
  name: "Arkansas Phipps Split Cropped Longsleeve",
  brandToken: "b_6fmfa45v57",
  brandName: "Gameday Social Apparel Co.®",
  imageUrl: "https://cdn.faire.com/fastly/10ae38ae7e0c1953ee123cc1a21288141450165f83bd803fcb8ffe79f9506e36.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4861b94d6abc14704bd7f2ebc65a37f58b3803db56c56f6071bf8355f31a8be8.jpeg",
    "https://cdn.faire.com/fastly/43a88a9b75c872005305a53e46e576ed7f029e49f768ddc06a79702836eb22d6.jpeg"
  ],
  priceDollars: 29.6,
  description: "Our Cropped Long Sleeve Crewneck! A GDS favorite featuring a raw hem, dropped shoulder, and the perfect lightweight material. It fits like a dream and adds a girly touch to your collegiate wardrobe. Pairs well with denim shorts and cowboy boots for game day!",
  tags: [],
  msrpDollars: 74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T22:14:31.397Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
